
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { getEnum } from "@/service/supplier-meta/api";
import { enumToOption } from "@/utils";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { Form } from "element-ui";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { cooperationModeEnum } from "@/service/supplier-meta/enums/cooperationModeEnum";
import { paymentTypeEnum } from "@/service/supplier-meta/enums/paymentTypeEnum";
import {
  cooperationModeOptions,
  CooperationModeOption,
} from "@/service/supplier-meta/common/selectOptionData";
import { getCooperationModeTips } from "@/service/supplier-meta/common/tips";
import { FormModel } from "@/service/common/entity/FormModel";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
@Component({
  components: {},
  watch: {
    "form.cooperationMode": {
      deep: true,
      immediate: true,
      handler(newVal: number[]) {
        const ctx = this as PaymentType;
        ctx.handleCooperationModeChange(newVal);
      },
    },
  },
})
export default class PaymentType extends SupplierForm {
  @Ref("form") elForm!: Form;
  form = {
    cooperationMode: [cooperationModeEnum.常规采销] as number[],
    paymentTypeItems: [] as CooperationModeOption[],
  };
  paymentTypeOptions: SelectOption[] = [];
  get rules(): ElementUIFormRules {
    return {
      cooperationMode: [
        { required: true, message: "请选择合作模式", trigger: "change" },
      ],
      paymentType: [
        {
          validator: (
            rules: unknown,
            value: unknown,
            callback: (msg?: string) => void
          ) => {
            const lostSelectedItems = this.form.paymentTypeItems.filter(
              (ele) => !(typeof ele.paymentType === "number")
            );
            if (lostSelectedItems.length > 0) {
              callback(
                `请选择${lostSelectedItems
                  .map((ele) => ele.label)
                  .join("、")}的付款方式`
              );
            } else {
              callback();
            }
          },
          trigger: "change",
        },
      ],
    };
  }
  get cooperationModeOptions(): CooperationModeOption[] {
    return cooperationModeOptions;
  }
  handleCooperationModeChange(val: number[]) {
    this.form.paymentTypeItems = this.cooperationModeOptions.filter(
      (ele) => val.indexOf(ele.value) >= 0
    );
  }

  created() {
    console.log(this);
    this.getOptions();
  }
  isCooperationModeDisabled(val: number) {
    return val === cooperationModeEnum.常规采销;
  }
  getCooperationModeTips = getCooperationModeTips;
  getOptions() {
    getEnum("PaymentTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.paymentTypeOptions = enumToOption(
          res.result.filter(
            (e) =>
              ![paymentTypeEnum.普通账期, paymentTypeEnum.阿里账期].includes(
                e.code as number
              ) && e.desc !== "请选择"
          )
        );
      }
    });
  }
  handlePaymentTypeChange() {
    this.elForm.validateField("paymentType");
  }
  getFormRef(): Form {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      enterpriseInfo: {
        paymentTypeList: this.form.paymentTypeItems.map((ele) => ({
          cooperationMode: ele.value,
          paymentType: ele.paymentType,
        })),
      },
    };
  }
  patchFormData(formData: FormModel) {
    const data = formData as any as SupplierInfoSubmitBO;
    if (Array.isArray(data?.enterpriseInfo?.paymentTypeList)) {
      const cooperationModeList: number[] = [];
      const paymentTypeItems: CooperationModeOption[] = [];
      data.enterpriseInfo.paymentTypeList.forEach((ele) => {
        const matchCooperationModeOption = this.cooperationModeOptions.find(
          (opt) => opt.value === ele.cooperationMode
        );
        cooperationModeList.push(ele.cooperationMode);
        if (matchCooperationModeOption) {
          matchCooperationModeOption.paymentType = ele.paymentType;
          paymentTypeItems.push(matchCooperationModeOption);
        }
      });
      this.form.cooperationMode = cooperationModeList;
      this.form.paymentTypeItems = paymentTypeItems;
    }
  }
}
